type ArrowLeftIconProps = {
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const ArrowLeftIcon = (props: ArrowLeftIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M5.99967 12.6666L6.93967 11.7266L3.88634 8.66659H14.6663V7.33325H3.88634L6.94634 4.27325L5.99967 3.33325L1.33301 7.99992L5.99967 12.6666Z"
      fill="currentColor"
    />
  </svg>
);
